import type { ReactNode } from 'react';
import { LAYOUT_MAIN, LAYOUT_MAX_WIDTH, type LayoutWidth } from './tokens';

interface AppMainProps {
  children: ReactNode;
  width?: LayoutWidth;
  className?: string;
}

export function AppMain({ children, width = 'default', className = '' }: AppMainProps) {
  return (
    <main className={`${LAYOUT_MAIN} ${LAYOUT_MAX_WIDTH[width]} ${className}`.trim()}>
      {children}
    </main>
  );
}
